import React from "react";
import "./AccessPending.css";

const AccessPending = () => {
  return (
    <div className="pending-container">
      <div className="pending-card">
        <img
          src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
          alt="Pending"
          className="pending-icon"
        />
        <h2 className="pending-title">Access Pending</h2>
        <p className="pending-text">
          Your account is created but learning access is not yet activated. Our
          team will verify and grant access shortly.
        </p>
      </div>
    </div>
  );
};

export default AccessPending;
